export interface Customer {
  id: string;
  key: string;
  name: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  townCity: string;
  region: string;
  postCode: string;
  countryName: string;
  tel: string;
  fax: string;
  mobileNo: string;
  email: string;
  web: string;
  vatRegNo: string;
  patternBook: string;
  currencyCode: string;
  CompanyRegNo: string;
  Bank: string;
  Tax: string;
  PaymentTerm: string;
  SellingCompany: string;
  ConfirmationEmailAddress: string;
  DespatchNoteEmailAddress: string;
  InvoiceEmailAddress: string;
  CreditLimit: number;
  AccountCode: string;
  DeliveryTerm: string;
  SettlementTerm: string;
  ModeOfTransport: string;
  Shipper: string;
  Port: string;
  EORINumber: string;
  NominalAccount: string;
  Proforma: string;
  PriceList: string;
  agentKey: string;
  agentName: string;
  salesDiscountKey: string;
  salesDiscountDescription: string;
  obsolete: string;
  hasCustomerPortalUser: boolean;
}
